export const ruleOptions = [
    {
        step: 'bureau_fraud_occurrences',
        name: 'Consulta de fraudes em Bureau',
        description: 'Classificação de risco de fraude do assinante encontrada em Bureau é igual ou superior ao nível configurado.',
        type: 'risk_level'
    },
    {
        step: 'liveness',
        name: 'Liveness',
        description: 'Assinante foi identificado como fraudador na etapa de liveness.',
        type: 'boolean'
    },
    {
        step: 'fraud_face_matches',
        name: 'Banco de fraudes',
        description: 'Assinante possui face encontrada no banco de fraudes.',
        type: 'boolean'
    },
    {
        step: 'brazil_geolocation',
        name: 'Assinatura fora do Brasil',
        description: 'Processo de assinatura não foi feita no Brasil.',
        type: 'boolean'
    },
    {
        step: 'device_key_blocklist',
        name: 'Lista de dispositivos bloqueados',
        description: 'Lista de dispositivos bloqueados.',
        type: 'boolean'
    },    
    {    
        step: 'same_ip_different_document_numbers',
        name: 'Mesmo IP, diferentes CPFs',
        description: 'Se existirem outros processos de assinaturas no mesmo IP para número de documentos diferentes nos últimos 30 dias.',
        type: 'boolean'
    },
    {
        step: 'facematch_document',
        name: 'Grau de similaridade com documento',
        description: 'Pontuação de checagem de simlaridade de face com documento - OCR.',
        type: 'numeric'
    },
    {
        step: 'face_validation',
        name: 'Score de validação de face',
        description: 'Pontuação de validação de face',
        type: 'numeric'
    },
    {
        step: 'liveness_flags',
        name: 'Liveness - Indicadores',
        description: 'Lista de indicadores detectados durante a etapa de liveness.',
        type: 'list_presence'
    },
    {
        step: 'ocr_flags',
        name: 'OCR - Indicadores',
        description: 'Lista de indicadores detectados durante a etapa de OCR.',
        type: 'list_presence'
    },
    {
        step: 'face_validation_document_fallback',
        name: 'Revalidação de biometria por documento',
        description: 'Quando o score de validação de face fica na faixa inconclusiva, a biometria é comparada com a foto do documento pessoal enviado pelo assinante, desde que os indicadores de OCR estejam nos estados exigidos.',
        type: 'composite'
    }
];

export const ocrFlags = [
    {
        value: 'found_illeterate_person_text',
        name: 'Pessoa analfabeta detectada pelo texto do documento'
    },
    {
        value: 'document_edges_issue',
        name: 'Parte do documento ocultada (rodapé, cabeçalho, bordas)'
    },
    {
        value: 'has_physical_damage',
        name: 'Documento apresenta danos físicos'
    },
    {
        value: 'has_textual_legibility_issues',
        name: 'Documento apresenta problemas de ilegilibilidade'
    },
    {
        value: 'document_tampering',
        name: 'Documento ou foto facial com traços de adulteração'
    },
    {
        value: 'screen_display_detected',
        name: 'Documento exibido em uma tela '
    },
    {
        value: 'found_anomalous_pdf_creator_or_producer',
        name: 'Criador ou produtor do PDF é incomum'
    },
    {
        value: 'creation_and_modification_date_mismatch',
        name: 'Data de criação e modificação do PDF são diferentes'
    },
    {
        value: 'cpf_signer_mismatch',
        name: 'CPF do assinante divergente do documento'
    }
]

export const livenessFlags = [
    {
        value: 'multiple_people',
        name: 'Múltiplas pessoas detectadas na sessão de liveness'
    }
]

export const riskClassificationLevels = [
    {
        value: 'LOW',
        name: 'Baixo'
    },
    {
        value: 'MEDIUM',
        name: 'Médio'
    },
    {
        value: 'HIGH',
        name: 'Alto'
    },
    {
        value: 'VERY_HIGH',
        name: 'Muito alto'
    }
]

export const DEFAULT_RISK_CLASSIFICATION_LEVEL = 'MEDIUM'

export const mapRuleNameByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.name ?? 'Not mapped rule name'
}

export const mapRuleTypeByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.type ?? ''
}

export const mapFlagName = (flag) => {
    switch (flag) {
        case 'found_illeterate_person_text':
            return 'Pessoa analfabeta'
        case 'multiple_people':
            return 'Múltiplas pessoas'
        case 'document_edges_issue':
            return 'Parte do documento foi ocultada'
        case 'found_state_text':
            return 'Encontrou estado'
        case 'found_footer_text':
            return 'Encontrou rodapé'
        case 'found_header_text':
            return 'Encontrou cabeçalho'
        case 'all_edges_detected':
            return 'Possível ocultação de contorno'
        case 'found_side_text':
            return 'Encontrou texto lateral'
        case 'screen_display_detected':
            return 'Documento exibido em uma tela'
        case 'text_tampering_detected':
            return 'Adulteração de conteúdo'
        case 'face_tampering_detected':
            return 'Foto facial adulterada'
        case 'has_physical_damage':
            return 'Documento apresenta danos físicos'
        case 'has_textual_legibility_issues':
            return 'Problemas de legibilidade'
        case 'document_tampering':
            return 'Documento ou foto facial com traços de adulteração'
        case 'found_anomalous_pdf_creator_or_producer':
            return 'Criador ou produtor do PDF é incomum'
        case 'creation_and_modification_date_mismatch':
            return 'Data de criação e modificação do PDF são diferentes'
        case 'cpf_signer_mismatch':
            return 'CPF do assinante divergente do documento'
        default:
            return 'Indicador não mapeado'
    }
}

export const mapRiskClassificationName = (level) => {
    switch (level) {
        case 'LOW':
            return 'Baixo'
        case 'MEDIUM':
            return 'Médio'
        case 'HIGH':
            return 'Alto'
        case 'VERY_HIGH':
            return 'Muito alto'
        default:
            return 'Nível de risco não mapeado'
    }
}

export const mapRuleDecisionByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.description ?? 'Not mapped rule description'
}


export const repprovementDecisions = [
    {
        value: 'reproved',
        name: 'Reprovar'
    },
    {
        value: 'in_manual_analysis',
        name: 'Análise manual'
    }
]

export const mapRuleDecisionName = (decision) => {
    let decisionFound = repprovementDecisions.find(rule => rule.value === decision)
    return decisionFound?.name ?? 'Not mapped decision name'
}

export const fallbackDecisions = [
    {
        value: 'approved',
        name: 'Aprovar'
    },
    {
        value: 'in_manual_analysis',
        name: 'Análise manual'
    }
]

export const floorComparisonTypes = [
    {
        value: 'greater_or_equal',
        name: 'inclui o valor'
    },
    {
        value: 'greater',
        name: 'exclui o valor'
    }
]

export const ceilingComparisonTypes = [
    {
        value: 'less_or_equal',
        name: 'inclui o valor'
    },
    {
        value: 'less',
        name: 'exclui o valor'
    }
]

export const documentComparisonTypes = [
    {
        value: 'less_or_equal',
        name: 'maior que o valor'
    },
    {
        value: 'less',
        name: 'maior ou igual ao valor'
    }
]

export const expectedFlagStates = [
    {
        value: 'true',
        name: 'Sim'
    },
    {
        value: 'false',
        name: 'Não'
    }
]

export const DEFAULT_INCONCLUSIVE_FLOOR = '50'
export const DEFAULT_INCONCLUSIVE_CEILING = '60'
export const DEFAULT_DOCUMENT_SIMILARITY_THRESHOLD = '80'
export const DEFAULT_FLOOR_COMPARISON_TYPE = 'greater_or_equal'
export const DEFAULT_CEILING_COMPARISON_TYPE = 'less_or_equal'
export const DEFAULT_DOCUMENT_COMPARISON_TYPE = 'less_or_equal'
export const DEFAULT_FALLBACK_DECISION = 'approved'

export const mapFallbackDecisionName = (decision) => {
    let decisionFound = fallbackDecisions.find(item => item.value === decision)
    return decisionFound?.name ?? 'Not mapped decision name'
}

export const mapRangeEdgeName = (comparisonType) => {
    switch (comparisonType) {
        case 'greater_or_equal':
            return 'inclusivo'
        case 'less_or_equal':
            return 'inclusivo'
        case 'greater':
            return 'exclusivo'
        case 'less':
            return 'exclusivo'
        default:
            return 'inclusivo'
    }
}

export const mapDocumentComparisonName = (comparisonType) => {
    switch (comparisonType) {
        case 'less':
            return 'maior ou igual a'
        default:
            return 'maior que'
    }
}

export const mapExpectedFlagStateName = (expected) => {
    if (expected) {
        return 'precisa estar presente'
    }
    return 'precisa estar ausente'
}

export const ATOMIC_OCR_FLAG_VALUES = [
    'found_illeterate_person_text',
    'has_physical_damage',
    'has_textual_legibility_issues',
    'screen_display_detected',
    'found_anomalous_pdf_creator_or_producer',
    'creation_and_modification_date_mismatch',
    'found_state_text',
    'found_footer_text',
    'found_header_text',
    'found_side_text',
    'all_edges_detected',
    'text_tampering_detected',
    'face_tampering_detected',
    'cpf_signer_mismatch'
]

export const ocrAtomicFlags = ATOMIC_OCR_FLAG_VALUES.map((flag) => ({ value: flag, name: mapFlagName(flag) }))

export const isAtomicOcrFlag = (flag) => {
    return ATOMIC_OCR_FLAG_VALUES.includes(flag)
}

export const mapAtomicFlagName = (flag) => {
    return mapFlagName(flag)
}




